export const CONTACT_STATUS = {
    PENDING: "pending",
    IN_PROGRESS: "in_progress",
    RESOLVED: "resolved",
};

export const CONTACT_STATUS_OPTIONS = [
    {
        value: CONTACT_STATUS.PENDING,
        label: "Chờ xử lý",
    },
    {
        value: CONTACT_STATUS.IN_PROGRESS,
        label: "Đang xử lý",
    },
    {
        value: CONTACT_STATUS.RESOLVED,
        label: "Đã xử lý",
    },
];

export const CONTACT_PAGE_SIZE = 10;

export const CONTACT_FILTER_INITIAL = {
    keyword: "",
    status: "",
    startDate: "",
    endDate: "",
};